<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>{{exchange.name}}</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row edit-exchange-form">
            <div [ngClass]="{'mb-3': form.controls[0].errors?.length > 0}" class="col-12">
                <app-panel-input
                    [control]="form.controls[0]"
                    [formControlName]="form.controls[0].name"
                ></app-panel-input>
            </div>
            <div [ngClass]="{'mb-3': form.controls[1].errors?.length > 0}" class="col-12">
                <app-textarea
                    [control]="form.controls[1]"
                    [formControlName]="form.controls[1].name"
                ></app-textarea>
            </div>
            <div [ngClass]="{'mb-3': form.controls[2].errors?.length > 0}" class="col-12">
                <app-select
                    [control]="form.controls[2]"
                    [formControlName]="form.controls[2].name"
                ></app-select>
            </div>
            <div [ngClass]="{'mb-3': form.controls[3].errors?.length > 0}" class="col-12">
                <app-select
                    [control]="form.controls[3]"
                    [formControlName]="form.controls[3].name"
                ></app-select>
            </div>
            <div [ngClass]="{'mb-3': form.controls[4].errors?.length > 0}" class="col-12">
                <app-select
                    [control]="form.controls[4]"
                    [formControlName]="form.controls[4].name"
                ></app-select>
            </div>
        </form>
    </ng-container>
</app-dialog>
